import { createSlice } from '@reduxjs/toolkit';

interface IArtifactsConfigState {
    gridView: boolean
    createArtifactModal: boolean
    formDisabled: boolean
    isNewForm: boolean
}

const initialState: IArtifactsConfigState = {
    gridView: true,
    createArtifactModal: false,
    formDisabled: false,
    isNewForm: true,
  };

  const artifactsConfigSlice = createSlice({
    name: 'artifacts-config',
    initialState,
    reducers: {
      setGridView(state, action){
        state.gridView = action.payload;
      },
      setCreateArtifactModal(state, action) {
        state.createArtifactModal = action.payload;
      },
      setFormDisabled(state, action) {
        state.formDisabled = action.payload;
      },
      setIsNewForm(state, action) {
        state.isNewForm = action.payload;
      },
      resetArtifactsConfigSlice(){
        return initialState;
      }
    }
  });
  
  export const { 
    setGridView,
    setCreateArtifactModal,
    setFormDisabled,
    setIsNewForm,resetArtifactsConfigSlice } = artifactsConfigSlice.actions;
  export default artifactsConfigSlice.reducer;